import FindPanel from './FindPanel';

export {
  FindPanel,
};



// WEBPACK FOOTER //
// ./src/components/page/FindDuplicates/components/index.js